import { IFilter } from "@saleor/components/Filter";
import { AutocompleteFilterOpts, FilterOpts, MinMax } from "@saleor/types";
import {
  createAutocompleteField,
  createDateField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum OrderLinesFilterKeys {
  brand = "brand",
  mall = "mall",
  orderDate = "orderDate",
  completedAt = "completedAt"
}

export interface OrderLinesListFilterOpts {
  orderDate: FilterOpts<MinMax>;
  completedAt: FilterOpts<MinMax>;
  brand: FilterOpts<string[]> & AutocompleteFilterOpts;
  mall: FilterOpts<string[]> & AutocompleteFilterOpts;
}

const messages = defineMessages({
  brand: {
    defaultMessage: "Brand",
    description: "brand"
  },
  completedAt: {
    defaultMessage: "Order Completion Date",
    description: "order completetion date"
  },
  mall: {
    defaultMessage: "Mall",
    description: "mall name"
  },

  orderDate: {
    defaultMessage: "Order Created Date",
    description: "order created date"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: OrderLinesListFilterOpts
): IFilter<OrderLinesFilterKeys> {
  return [
    {
      ...createDateField(
        OrderLinesFilterKeys.orderDate,
        intl.formatMessage(messages.orderDate),
        opts.orderDate.value
      ),
      active: opts.orderDate.active
    },
    {
      ...createDateField(
        OrderLinesFilterKeys.completedAt,
        intl.formatMessage(messages.completedAt),
        opts.completedAt.value
      ),
      active: opts.completedAt.active
    },
    {
      ...createAutocompleteField(
        OrderLinesFilterKeys.brand,
        intl.formatMessage(messages.brand),
        opts.brand.value,
        opts.brand.displayValues,
        true,
        opts.brand.choices,
        {
          hasMore: opts.brand.hasMore,
          initialSearch: "",
          loading: opts.brand.loading,
          onFetchMore: opts.brand.onFetchMore,
          onSearchChange: opts.brand.onSearchChange
        }
      ),
      active: opts.brand.active
    },
    {
      ...createAutocompleteField(
        OrderLinesFilterKeys.mall,
        intl.formatMessage(messages.mall),
        opts.mall.value,
        opts.mall.displayValues,
        true,
        opts.mall.choices,
        {
          hasMore: opts.mall.hasMore,
          initialSearch: "",
          loading: opts.mall.loading,
          onFetchMore: opts.mall.onFetchMore,
          onSearchChange: opts.mall.onSearchChange
        }
      ),
      active: opts.mall.active
    }
  ];
}
